module.exports = __webpack_public_path__ + "img/支付宝.32cf345a.png";